<template>
  <div>
    <Topbar title="Mon profil" />
    <div class="Section">
      <form>
        <div class="InputGroup">
          <label class="InputGroup__label">Nom</label>
          <Input :readonly="true" :value="user.name" />
        </div>
        <div class="InputGroup">
          <label class="InputGroup__label">Type de client</label>
          <Input :readonly="true" :value="user.kind" />
        </div>
        <div class="InputGroup">
          <label class="InputGroup__label">Email</label>
          <Input :readonly="true" :value="user.email" />
        </div>
        <div class="InputGroup">
          <label class="InputGroup__label">Téléphone</label>
          <Input :readonly="true" :value="user.phone" />
        </div>
        <router-link class="Button Button--primary" :to="{name: 'PasswordEdition'}">Réinitialiser mon mot de passe</router-link>
        <Button class="Button--secondary" :loading="loading" @click.native="toggleNewsletter">{{ newsletterBtnText }}</Button>
      </form>
    </div>
  </div>

</template>

<script>
import { mapState } from "vuex";
import Input from "../components/Input";
import notificationService from "../services/notification";
import Button from "../components/Button";
import userService from "../services/user";

export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    newsletterBtnText() {
      return this.user.newsletter ? "Ne plus recevoir la newsletter" : "S'abonner à la newsletter";
    }
  },
  methods: {
    toggleNewsletter() {
      this.loading = true;

      return userService.updateUser()
        .then(() => this.$store.dispatch("auth/getUser"))
        .catch(err => notificationService.error(err.message, err.errors))
        .finally(() => this.loading = false);
    }
  },
  components: { Input, Button }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.Button {
  width: 100%;
  margin-bottom: $global-margin;
}

form {
  max-width: 22em;
}
</style>
